import { createTheme } from "@mui/material/styles";


export const luxuryTheme = createTheme({
  palette: {
    primary: {
      main: "#d4af37", // ذهبي فاخر
      light: "#f4e5c2",
      dark: "#b8941f",
      contrastText: "#fff",
    },
    secondary: {
      main: "#2c3e50", // أزرق داكن أنيق
      light: "#34495e",
      dark: "#1a252f",
      contrastText: "#fff",
    },
    error: {
      main: "#e74c3c",
      light: "#ff6b6b",
      dark: "#c0392b",
    },
    success: {
      main: "#27ae60",
      light: "#2ecc71",
      dark: "#229954",
    },
    warning: {
      main: "#f39c12",
      light: "#f1c40f",
      dark: "#e67e22",
    },
    info: {
      main: "#3498db",
      light: "#5dade2",
      dark: "#2980b9",
    },
    background: {
      default: "#ffffff",
      paper: "#fafafa",
      luxury: "#f8f9fa",
      gradient: "linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%)",
      gradientReverse: "linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%)",
    },
    text: {
      primary: "#2c3e50",
      secondary: "#7f8c8d",
      disabled: "#bdc3c7",
    },
    divider: "rgba(212, 175, 55, 0.2)",
    gradient: {
      gold: "linear-gradient(135deg, #d4af37 0%, #f4e5c2 100%)",
      goldReverse: "linear-gradient(135deg, #f4e5c2 0%, #d4af37 100%)",
      dark: "linear-gradient(135deg, #2c3e50 0%, #34495e 100%)",
      red: "linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)",
      green: "linear-gradient(135deg, #27ae60 0%, #2ecc71 100%)",
      fire: "linear-gradient(135deg, #ff6b6b 0%, #ff8e53 100%)",
      subtle: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
      subtleGray: "linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%)",
    },
  },
  typography: {
    fontFamily: "'Cairo', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    h1: {
      fontWeight: 800,
      letterSpacing: "-1px",
      fontSize: "3.5rem",
      "@media (max-width:600px)": {
        fontSize: "2.5rem",
      },
    },
    h2: {
      fontWeight: 800,
      letterSpacing: "-0.8px",
      fontSize: "3rem",
      "@media (max-width:600px)": {
        fontSize: "2rem",
      },
    },
    h3: {
      fontWeight: 800,
      letterSpacing: "-0.5px",
      fontSize: "2.5rem",
      "@media (max-width:600px)": {
        fontSize: "1.75rem",
      },
    },
    h4: {
      fontWeight: 700,
      letterSpacing: "-0.3px",
      fontSize: "2rem",
      "@media (max-width:600px)": {
        fontSize: "1.5rem",
      },
    },
    h5: {
      fontWeight: 700,
      letterSpacing: "-0.2px",
      fontSize: "1.5rem",
    },
    h6: {
      fontWeight: 700,
      fontSize: "1.25rem",
    },
    subtitle1: {
      fontWeight: 600,
      fontSize: "1rem",
    },
    subtitle2: {
      fontWeight: 600,
      fontSize: "0.875rem",
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.6,
    },
    body2: {
      fontSize: "0.875rem",
      lineHeight: 1.5,
    },
    button: {
      fontWeight: 700,
      textTransform: "none",
      fontSize: "1rem",
    },
    caption: {
      fontSize: "0.75rem",
      lineHeight: 1.4,
    },
  },
  shadows: [
    "none",
    "0 2px 4px rgba(0,0,0,0.05)",
    "0 4px 8px rgba(0,0,0,0.08)",
    "0 8px 16px rgba(0,0,0,0.1)",
    "0 12px 24px rgba(0,0,0,0.12)",
    "0 16px 32px rgba(0,0,0,0.15)",
    "0 20px 40px rgba(0,0,0,0.15)",
    "0 24px 48px rgba(0,0,0,0.18)",
    "0 2px 4px rgba(212, 175, 55, 0.2)",
    "0 4px 8px rgba(212, 175, 55, 0.25)",
    "0 8px 16px rgba(212, 175, 55, 0.3)",
    "0 12px 24px rgba(212, 175, 55, 0.35)",
    "0 2px 8px rgba(44, 62, 80, 0.15)",
    "0 4px 12px rgba(44, 62, 80, 0.2)",
    "0 8px 20px rgba(44, 62, 80, 0.25)",
    "0 2px 8px rgba(231, 76, 60, 0.3)",
    "0 4px 12px rgba(231, 76, 60, 0.4)",
    "0 2px 8px rgba(46, 204, 113, 0.3)",
    "0 4px 12px rgba(46, 204, 113, 0.4)",
    "0 2px 8px rgba(255, 107, 107, 0.3)",
    "0 4px 12px rgba(255, 107, 107, 0.4)",
    "0 8px 24px rgba(0,0,0,0.12)",
    "0 12px 32px rgba(0,0,0,0.15)",
    "0 16px 40px rgba(0,0,0,0.18)",
    "0 20px 48px rgba(0,0,0,0.2)",
  ],
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
          border: "1px solid rgba(0,0,0,0.08)",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          borderRadius: 8,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
          fontWeight: 700,
          boxShadow: "none",
          "&:hover": {
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          },
        },
        contained: {
          background: "linear-gradient(135deg, #d4af37 0%, #f4e5c2 100%)",
          color: "#fff",
          "&:hover": {
            background: "linear-gradient(135deg, #b8941f 0%, #d4af37 100%)",
          },
        },
        outlined: {
          borderColor: "rgba(212, 175, 55, 0.5)",
          "&:hover": {
            borderColor: "#d4af37",
            background: "rgba(212, 175, 55, 0.05)",
          },
        },
      },
    },
    MuiCardActionArea: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          border: "2px solid",
          borderColor: "#f4e5c2",
        },
      },
    },
    MuiRating: {
      styleOverrides: {
        iconFilled: {
          color: "#ffd700",
        },
        iconEmpty: {
          color: "rgba(212, 175, 55, 0.3)",
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

// Custom animations
export const animations = {
  pulse: {
    "@keyframes pulse": {
      "0%, 100%": { transform: "scale(1)" },
      "50%": { transform: "scale(1.05)" },
    },
    animation: "pulse 2s ease-in-out infinite",
  },
  fadeInUp: {
    "@keyframes fadeInUp": {
      "0%": { opacity: 0, transform: "translateY(20px)" },
      "100%": { opacity: 1, transform: "translateY(0)" },
    },
    animation: "fadeInUp 0.6s ease-out",
  },
  slideIn: {
    "@keyframes slideIn": {
      "0%": { transform: "translateX(-20px)", opacity: 0 },
      "100%": { transform: "translateX(0)", opacity: 1 },
    },
    animation: "slideIn 0.5s ease-out",
  },
};

// Utility functions for theme
export const getGradientText = (gradient = "gold") => ({
  background: luxuryTheme.palette.gradient[gradient],
  backgroundClip: "text",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
});

export const getHoverEffect = (scale = 1.05) => ({
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  "&:hover": {
    transform: `scale(${scale})`,
  },
});

export const getCardHover = () => ({
  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
  "&:hover": {
    transform: "translateY(-12px)",
    boxShadow: luxuryTheme.shadows[6],
    borderColor: luxuryTheme.palette.primary.main,
  },
});
